module.exports = __webpack_public_path__ + "static/media/gameFossilFinder.e340bf8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFossilFinder.png
// module id = 2611
// module chunks = 0